import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Box } from 'components/layout/Box/Box'
import { StepButton } from 'components/shared/StepButton/StepButton'
import { StepProgressGroup } from 'components/shared/StepProgressGroup/StepProgressGroup'
import { CategoryDetails } from '../../pages/CategoryDetails/CategoryDetails'
import { Introduction } from '../../pages/Introduction/Introduction'
import { Report } from '../../pages/Report/Report'
import { Summary } from '../../pages/Summary/Summary'

import {
  InterviewHandlersContext,
  InterviewStateContext,
} from 'components/modules/interview/context'
import { INTERVIEW_STEPS } from 'ducks/router'
import { useContext } from 'hooks'

import { ChevronLeftIcon, ChevronRightIcon } from 'components/shared/Icon/model'

import styles from './Main.module.scss'

const getSteps = () => ({
  [INTERVIEW_STEPS.INTRODUCTION]: <Introduction />,
  [INTERVIEW_STEPS.REPORT]: <Report />,
  [INTERVIEW_STEPS.SUMMARY]: <Summary />,
})

export const Main = () => {
  const state = useContext(InterviewStateContext)
  const handlers = useContext(InterviewHandlersContext)

  const {
    activeStep,
    steps,
    isCategoryStep,
    isPreviousStepDisabled,
    isNextStepDisabled,
    isIntroductionStep,
    isReportStep,
    isSummaryStep,
  } = state
  const {
    handleChangeNextStep,
    handleChangePreviousStep,
    handleChangeStep,
  } = handlers

  const staticSteps = getSteps()

  return (
    <Box
      align="center"
      className={cx(styles.main, { [styles.reportWidth]: isReportStep })}
      direction="column"
      tagName="main"
    >
      {R.or(isCategoryStep, isSummaryStep) ? (
        <StepProgressGroup
          className={styles.steps}
          size="large"
          steps={steps}
          onStep={handleChangeStep}
          {...{ activeStep }}
        />
      ) : null}
      <Box
        align="center"
        className={cx(styles.container, {
          [styles.fullHeight]: R.or(isIntroductionStep, isReportStep),
        })}
        justify="center"
      >
        {R.or(isCategoryStep, isSummaryStep) ? (
          <StepButton
            ariaLabel="previous"
            icon={ChevronLeftIcon}
            size="medium"
            variant="outlined"
            onClick={handleChangePreviousStep}
            isDisabled={isPreviousStepDisabled}
          />
        ) : null}
        {staticSteps[activeStep] ?? <CategoryDetails key={activeStep} />}
        {R.or(isCategoryStep, isSummaryStep) ? (
          <StepButton
            ariaLabel="next"
            icon={ChevronRightIcon}
            size="medium"
            variant="outlined"
            onClick={handleChangeNextStep}
            isDisabled={isNextStepDisabled}
          />
        ) : null}
      </Box>
    </Box>
  )
}
